import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-2" }
const _hoisted_2 = { class: "form-custom mt-2" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "bt-icon bt-icon--xs" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = { class: "btn-stripped" }
const _hoisted_9 = { class: "btn-stripped" }
const _hoisted_10 = { class: "p-field-label mt-3" }
const _hoisted_11 = { class: "list-unstyled" }
const _hoisted_12 = { class: "p-field-label mt-3" }
const _hoisted_13 = {
  key: 0,
  class: "fs-13 label-error",
  style: {"position":"absolute"}
}
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { class: "p-field-label" }
const _hoisted_16 = {
  key: 0,
  for: "codecheck",
  class: "fs-13 label-valid"
}
const _hoisted_17 = {
  key: 1,
  for: "codecheck",
  class: "fs-13 label-error"
}
const _hoisted_18 = { class: "mt-3 d-flex align-items-center" }
const _hoisted_19 = { class: "px-2 custom-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_Password = _resolveComponent("Password")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogShareCode = _resolveComponent("DialogShareCode")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_ElScrollbar, { class: "details-panel-content" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, [
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodePlaceHolder")), 1),
                _createVNode(_component_ElDropdown, {
                  class: "ml-auto",
                  trigger: "click",
                  placement: "bottom-end",
                  "popper-class": "el-dropdown__popper el-dropdown--context"
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_ElDropdownMenu, { style: {"width":"200px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElDropdownItem, {
                          disabled: !_ctx.enableShare,
                          onClick: _ctx.shareCode
                        }, {
                          default: _withCtx(() => [
                            _createVNode("button", _hoisted_8, _toDisplayString(_ctx.$t(
                                                    "AppResourceEP.ShareKeypadCode"
                                                )), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_ElDropdownItem, { onClick: _ctx.codeGenerator }, {
                          default: _withCtx(() => [
                            _createVNode("button", _hoisted_9, _toDisplayString(_ctx.$t(
                                                    "AppResourceEP.GenerateKeypadCode"
                                                )), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                      class: "p-button-rounded p-button-outlined ml-auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode("span", _hoisted_6, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                            require(`@/assets/images/icons/icon-ellipsis-v.svg`)
                                        ,
                            "aria-label": "icon-ellipsis"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.More")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", null, [
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction")), 1),
                _createVNode("ul", _hoisted_11, [
                  _createVNode("li", null, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Lenght", [_ctx.currentEntrancePlant.keypadCodeRequiredLength])), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.$t(
                                        "AppResourceEP.AccessCodeInstruction_Different"
                                    )), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.$t(
                                        "AppResourceEP.AccessCodeInstruction_Consecutive"
                                    )), 1),
                  _createVNode("li", null, _toDisplayString(_ctx.$t(
                                        "AppResourceEP.AccessCodeInstruction_SameNumber"
                                    )), 1)
                ])
              ]),
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCode")), 1),
              _createVNode(_component_Password, {
                disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                class: ["w-50", { 'w-100': !_ctx.isEdit }],
                toggleMask: "",
                feedback: false,
                modelValue: _ctx.keypadCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keypadCode = $event)),
                inputClass: {
                            'w-100': true,
                            'input-error': _ctx.lengthNotValid,
                        },
                onBlur: _ctx.checkCodeLength,
                onFocus: _ctx.resetLengthValidation
              }, null, 8, ["disabled", "modelValue", "inputClass", "class", "onBlur", "onFocus"]),
              _createVNode("div", null, [
                (_ctx.lengthNotValid)
                  ? (_openBlock(), _createBlock("label", _hoisted_13, _toDisplayString(_ctx.$t(`entrancePlant.codeLenghtOrNotNumbers`, {
                                    keypadCodeLength:
                                        _ctx.currentEntrancePlant.keypadCodeRequiredLength,
                                })), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeConfirmationUpper")), 1),
              _createVNode(_component_Password, {
                disabled: !_ctx.enableConfirmation||!_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                toggleMask: _ctx.enableConfirmation,
                id: "codecheck",
                class: ["w-50", { 'w-100': !_ctx.isEdit }],
                feedback: false,
                modelValue: _ctx.codeCheck,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.codeCheck = $event)),
                  _ctx.checkOnConfirmUpdated
                ],
                inputClass: {
                            'w-100': true,
                            'input-error': _ctx.codeNotValid,
                            'input-valid': _ctx.codeValid,
                        },
                onBlur: _ctx.checkCodeValid,
                onFocus: _ctx.resetValidation
              }, null, 8, ["disabled", "toggleMask", "modelValue", "inputClass", "class", "onUpdate:modelValue", "onBlur", "onFocus"]),
              _createVNode("div", null, [
                (_ctx.codeValid)
                  ? (_openBlock(), _createBlock("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.KeypadCodeConfirmationMatch")), 1))
                  : (_ctx.codeNotValid)
                    ? (_openBlock(), _createBlock("label", _hoisted_17, _toDisplayString(_ctx.$t(
                                    "AppResourceEP.KeypadCodeConfirmationDoesNotMatch"
                                )), 1))
                    : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_InlineSvgScoped, {
                class: "svg-icon",
                src: 
                                        require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                                    ,
                "aria-label": "icon-badge"
              }, null, 8, ["src"]),
              _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResourceEP.ChangeAccessCodeLengthInfo")), 1)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_DialogShareCode, {
      isVisible: _ctx.isVisibleDialogEditLabel,
      onHideDialog: _cache[3] || (_cache[3] = () => _ctx.isVisibleDialogEditLabel = false),
      onShareEmail: _ctx.onShareEmail
    }, null, 8, ["isVisible", "onShareEmail"])
  ], 64))
}